import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaCaretDown } from 'react-icons/fa';
import RichTextRenderer from 'components/RichTextRenderer';
import useSearchMatches from 'products/nomad_insurance/views/Policy/hooks/useSearchMatches';
import useSearchHighlight from 'products/nomad_insurance/views/Policy/hooks/useSearchHighlight';
import { useSearchContext } from 'products/nomad_insurance/views/Policy/hooks/useSearch';
import CostCoverage from '../CostCoverage';
import {
  StyledSection,
  SectionTitle,
  SectionContent,
  StyledSubSection,
  SubsectionTitle
} from './styled';

const SubSection = ({ subsection }) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const { debouncedSearch: search } = useSearchContext();
  const { isSearchMatch } = useSearchMatches(useMemo(() => [subsection], [subsection]));
  const [ref, highlight] = useSearchHighlight();

  useEffect(() => {
    if (isSearchMatch && search.length > 0) {
      setShowAnswer(true);
    }
  }, [isSearchMatch, search]);

  useEffect(() => {
    if (showAnswer) {
      highlight();
    }
  }, [showAnswer]);

  if (!isSearchMatch) {
    return null;
  }

  return (
    <StyledSubSection showAnswer={showAnswer} ref={ref}>
      <SubsectionTitle showAnswer={showAnswer} onClick={() => setShowAnswer(!showAnswer)}>
        <FaCaretDown />
        <RichTextRenderer richText={subsection.fields.title} />
      </SubsectionTitle>
      {showAnswer && (
        <>
          <RichTextRenderer richText={subsection.fields.content} />
          <CostCoverage
            safetyWingCovers={subsection.fields.safetyWingCovers}
            youCover={subsection.fields.youCover}
          />
        </>
      )}
    </StyledSubSection>
  );
};

SubSection.propTypes = {
  subsection: PropTypes.object.isRequired
};

const Section = ({ section }) => {
  const { isSearchMatch } = useSearchMatches(useMemo(() => [section], [section]));

  if (!isSearchMatch) return null;

  return (
    <StyledSection>
      <SectionTitle>{section.fields.title}</SectionTitle>
      <SectionContent>
        <RichTextRenderer richText={section.fields.content} />
      </SectionContent>
      {section.fields.subsections?.map((subsection, i) => {
        return <SubSection key={i} subsection={subsection} />;
      })}
    </StyledSection>
  );
};

Section.propTypes = {
  section: PropTypes.object.isRequired
};

export default Section;
